import React from "react";
import PropTypes from "prop-types";
import { Select3, Form } from "@weezevent/nacre";
import {
	ATTENDEE_ENTRY_TYPE,
	BUYER_ENTRY_TYPE
} from "../../../../models/forms-with-entry-usage";

const FieldSelector = ({
	fields,
	selectedFieldId,
	selectedEntryType,
	onChange,
	t
}) => {
	const fieldOptions = React.useMemo(() => {
		return fields.map(field => ({
			value: field.getFormFieldWeezId(),
			text: field.getFormFieldName(),
			fieldType: field.getFormFieldType()
		}));
	}, [fields]);

	const entryTypeLabel = React.useMemo(() => {
		if (selectedEntryType === ATTENDEE_ENTRY_TYPE) {
			return t(
				"access.attendees.attendeesList.filters.formFields.attendee"
			);
		} else if (selectedEntryType === BUYER_ENTRY_TYPE) {
			return t("access.attendees.attendeesList.filters.formFields.buyer");
		}
		return "";
	}, [selectedEntryType, t]);

	return (
		<Form.Field>
			<Form.Label>
				{entryTypeLabel && `${entryTypeLabel} `}
				{t("access.attendees.attendeesList.filters.formFields.field")}
			</Form.Label>
			<Select3
				options={fieldOptions}
				value={selectedFieldId || ""}
				onChange={onChange}
				placeholder={t(
					"access.attendees.attendeesList.filters.formFields.selectField"
				)}
			/>
		</Form.Field>
	);
};

FieldSelector.propTypes = {
	fields: PropTypes.array.isRequired,
	selectedFieldId: PropTypes.string,
	selectedEntryType: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	t: PropTypes.func.isRequired
};

export default FieldSelector;
